module.exports = __webpack_public_path__ + "static/seven-brief-lessons-on-physics-30a3cdfdb2fe5fc7559802543195296d.jpg";